import React from 'react';
import { useSiteSearch } from '../site-search/provider';
import SearchBar from '../../primitives/search-bar';
import { SITE_SEARCH_PLACEHOLDER } from '../../../constants';

const SiteSearchBar = ({ placeholder, onFocus }: {
    placeholder?: string,
    onFocus?: () => void
}): JSX.Element => {
    const { setVisible } = useSiteSearch();
    const [value, onChange] = React.useState<string>('');

    const openPopover = (): void => {
        setVisible(true);
        if (onFocus) {
            onFocus();
        }
    };

    return (
        <SearchBar
            value={value}
            onChange={onChange}
            onFocus={openPopover}
            placeholder={placeholder || SITE_SEARCH_PLACEHOLDER}
        />
    );
};

export default SiteSearchBar;
